// import { getCookie } from './utils/cookie';

const API = process.env.REACT_APP_API_SERVER;
const SESSION_NAME = 'localhost';

const HTTP_CODES = { SERVER_ERROR: 500, NOT_FOUND: 404, BAD_REQUEST: 400 };

export const responseHandler = async (response, onFail) => {
    const responseError = Object.values(HTTP_CODES).includes(response.status);

    if (responseError) {
        if (onFail) return onFail();
    }

    let returnValue;
    try {
        returnValue = await response.text();
        if (returnValue) returnValue = JSON.parse(returnValue);
    } catch (e) {
        returnValue = response;
    }

    return returnValue;
};

// export async function authenticatedRequest(url, options, onFail) {
//     // const sessionToken = getCookie(SESSION_NAME);
//     const sessionToken = localStorage.getItem('BearerToken');

//     if (!sessionToken) {
//         console.error('No session found');
//         return { status: 401, message: 'Not Authenticated' };
//     }

//     const authenticatedOptions = { ...options };

//     if (!authenticatedOptions.headers) {
//         authenticatedOptions.headers = {};
//     }

//     authenticatedOptions.headers['Authorization'] = `Bearer ${sessionToken}`;

//     if (options.method !== 'GET' && authenticatedOptions.headers['Content-Type'] === undefined) {
//         authenticatedOptions.headers['Content-Type'] = 'application/json';
//     }

//     let response;
//     try {
//         response = await fetch(urlFormatter(url), authenticatedOptions);
//     } catch (error) {
//         if (onFail) return onFail(error);
//         return;
//     }

//     return responseHandler(response, onFail);
// }

export async function authenticatedRequest(url, options, onFail, requireAuth = true) {
    if (requireAuth) {
        const sessionToken = localStorage.getItem('BearerToken');
        if (!sessionToken) {
            // console.error('No session found');
            return { status: 401, message: 'Not Authenticated' };
        }

        if (!options.headers) {
            options.headers = {};
        }
        options.headers['Authorization'] = `Bearer ${sessionToken}`;

        if (options.method !== 'GET' && options.headers['Content-Type'] === undefined) {
            options.headers['Content-Type'] = 'application/json';
        }
    }

    let response;
    try {
        response = await fetch(urlFormatter(url), options);
    } catch (error) {
        if (onFail) return onFail(error);
        return;
    }

    return responseHandler(response, onFail);
}

export async function authenticatedDelete(url, onFail) {
    return authenticatedRequest(url, { method: 'DELETE' }, onFail);
}
export async function authenticatedDeletewithPayload(url, onFail, body = null) {
    return authenticatedRequest(
        url,
        {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: body ? JSON.stringify(body) : undefined
        },
        onFail
    );
}

export async function authenticatedFetch(url, onFail) {
    return authenticatedRequest(url, { method: 'GET' }, onFail);
}

export async function authenticatedPost(url, onFail, payload = null) {
    return authenticatedRequest(url, { method: 'POST', body: payload ? JSON.stringify(payload) : null }, onFail);
}

export async function authenticatedPut(url, onFail, payload = null) {
    return authenticatedRequest(url, { method: 'PUT', body: payload ? JSON.stringify(payload) : null }, onFail);
}

export async function authenticatedPatch(url, onFail, payload = null) {
    return authenticatedRequest(url, { method: 'PATCH', body: payload ? JSON.stringify(payload) : null }, onFail);
}
export async function authenticatedPatchFile(url, payload = null) {
    return authenticatedRequest(url, { method: 'PATCH', body: payload });
}

export const urlFormatter = (path) => {
    if (path.indexOf('http://') === 0 || path.indexOf('https://') === 0) {
        return path;
    }
    return `${API}${path}`;
};

export async function publicFetch(url, onFail) {
    return authenticatedRequest(url, { method: 'GET' }, onFail, false);
}
